import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  headerWrapper: {
    backgroundColor: '#F7F7F7',
    padding: '0.5rem',
    color: '#F37320',
    fontWeight: 'bold'
  },
  cardWrapper: {
    margin: '20px 10px',
    padding: '10px 25px',
  },
  cardData: {
    fontSize: '12px',
    color: '#6F6F6F',
    paddingBottom: '5px'
  },
  cardValue: {
    fontSize: '20px'
  },
  refreshIcon: {
    verticalAlign: 'middle',
    cursor: 'pointer'
  }
}))

export { useStyles }